import { render, staticRenderFns } from "./vipBotton.vue?vue&type=template&id=26be336b&scoped=true&"
import script from "./vipBotton.vue?vue&type=script&lang=ts&"
export * from "./vipBotton.vue?vue&type=script&lang=ts&"
import style0 from "./vipBotton.vue?vue&type=style&index=0&id=26be336b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26be336b",
  null
  
)

export default component.exports